import { Injectable, inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { KeycloakService, KeycloakAuthGuard } from 'keycloak-angular';
import { keycloakEnvironment } from 'src/environments/environment';

@Injectable()
export class AppAuthGuard extends KeycloakAuthGuard {
    protected router: Router;
    protected keycloakAngular: KeycloakService;

    constructor() {
        const router = inject(Router);
        const keycloakAngular = inject(KeycloakService);

        super(router, keycloakAngular);
    
        this.router = router;
        this.keycloakAngular = keycloakAngular;
    }

    isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return new Promise(async (resolve, reject) => {
            if (!this.authenticated && !route.data.isRegisterPage) {
                this.keycloakAngular.login({ prompt: 'login' });

                return;
            }

            this.handleRegisterAuthGuard(route.data);

            const requiredRoles = route.data.roles;
            if (!requiredRoles || requiredRoles.length === 0) {
                return resolve(true);
            } else {
                if (!this.roles || this.roles.length === 0) {
                    resolve(false);
                }
                let granted = false;
                for (const requiredRole of requiredRoles) {
                    if (this.roles.indexOf(requiredRole) > -1) {
                        granted = true;
                        break;
                    }
                }
                resolve(granted);
            }
        });
    }

    handleRegisterAuthGuard(data) {
      if(data.isRegisterPage && this.authenticated) {
          this.router.navigate(['/home']);
        }
    }


}
